module.exports = __webpack_public_path__ + "static/mpm-celebrate-2ecef1266b1092ee1398eefc40ec607a.jpg";